import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceIssueSecurityLevelProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-issue-security-level-project-limit',
	path: '/jira/settings/system/performance/metrics/issuesecuritylevel/projectlimit',
};
